import { Fragment, useCallback, useEffect, useState } from 'react';

import fetcher from 'api/fetcher';
import { parseISO, subMonths } from 'date-fns';
import { FILTER_STATUS_ENUM_SENDING, FILTER_STATUS_NEW, FILTER_STATUS_WAITING_DOC } from 'utils/constants/invoice';
import { formatDate } from 'utils/date';

import Button, { ButtonKind } from 'bloko/blocks/button';
import Checkbox from 'bloko/blocks/checkbox';
import { FormItem } from 'bloko/blocks/form';
import Gap from 'bloko/blocks/gap';
import InputText from 'bloko/blocks/inputText';
import urlParser from 'bloko/common/urlParser';

import useTrls from 'hooks/translation/useTrls';

import fetchSaveSettings from 'components/Admin/InvoiceDetail/Settings/fetchSaveSettings';
import TitleWithInvoiceNumber from 'components/Admin/InvoiceDetail/TitleWithInvoiceNumber';

import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/InvoiceDetail/Settings/Settings.less';

const Settings = () => {
    const invoice = useSelector((state) => state.invoiceDetail.invoice);

    const dispatch = useDispatch();

    const [payments, setPayments] = useState([]);
    const [isLoadPayments, setLoadPayments] = useState(true);
    const [auto, setAuto] = useState(invoice.auto);
    const [amount, setAmount] = useState(invoice.amount);
    const [enableBtn, setEnable] = useState(true);

    const trl = useTrls();

    useEffect(() => {
        const queryStr = urlParser.stringify({
            dateFrom: formatDate(subMonths(parseISO(invoice.createdAt), 1)),
            dateTo: formatDate(new Date()),
        });
        fetcher.get(`/api/v1/payments/byInvoice/${invoice.id}?${queryStr}`).then((payments) => {
            setLoadPayments(false);
            setPayments(payments);
        });
    }, [dispatch, invoice]);

    const saveSettings = useCallback(() => {
        dispatch(fetchSaveSettings(invoice, amount, setEnable));
    }, [amount, dispatch, invoice]);

    const showAutoCheckbox = [FILTER_STATUS_ENUM_SENDING, FILTER_STATUS_NEW, FILTER_STATUS_WAITING_DOC].includes(
        invoice.status
    );

    if (payments.length > 0 || isLoadPayments || !showAutoCheckbox) {
        return null;
    }

    return (
        <Gap bottom>
            <TitleWithInvoiceNumber
                titleBlock={trl('admin.Invoices.InvoicesDetail.Invoice.Settings.title')}
                {...invoice}
            />
            <div className="settings">
                <FormItem>
                    <Checkbox onChange={() => setAuto(!auto)} checked={!auto} disabled={!invoice.auto}>
                        {trl('admin.Invoices.InvoicesDetail.Invoice.Settings.Discount.auto')}
                    </Checkbox>
                </FormItem>
                {!auto && (
                    <Fragment>
                        <FormItem>
                            <InputText
                                prefix={trl('admin.Invoices.InvoicesDetail.Invoice.Settings.Discount.labelAmount')}
                                placeholder={trl('admin.Invoices.InvoicesDetail.Invoice.Settings.Discount.amount')}
                                value={`${amount}`}
                                onChange={(value) => setAmount(value)}
                            />
                        </FormItem>
                        <div className="settings__actions">
                            <div className="settings-actions__save">
                                <Button kind={ButtonKind.Primary} disabled={!enableBtn} onClick={saveSettings}>
                                    {trl('admin.Invoices.InvoicesDetail.Invoice.Settings.save')}
                                </Button>
                            </div>
                        </div>
                    </Fragment>
                )}
            </div>
        </Gap>
    );
};

export default Settings;
